module.exports = __webpack_public_path__ + "static/media/02-04.39f60d79.png";